/**
 * Tabblad Stellingen van de leerkracht: de stellingen die de beheerder
 * heeft klaargezet, alleen-lezen, en per stelling de chatsamenstelling
 * per leerjaar (onderdelen/ChatSamenstelling.js).
 */
import React, { useEffect, useState } from 'react';
import { basis } from '../stijlen';
import { StellingenLijst } from '../../../components/StellingenLijst';
import { ChatSamenstelling } from '../onderdelen/ChatSamenstelling';

export function Stellingen({ api }) {
  const [stellingen, setStellingen] = useState([]);
  const [laden, setLaden] = useState(false);
  const [gekozen, setGekozen] = useState(null);

  useEffect(() => {
    const laad = async () => {
      setLaden(true);
      try {
        const data = await api.haalStellingen();
        if (data.success) setStellingen(data.data);
      } catch (err) { console.error('Fout:', err); }
      finally { setLaden(false); }
    };
    laad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const bekijk = async (id) => {
    try {
      const data = await api.haalStelling(id);
      if (data.success) setGekozen(data.data);
    } catch (err) { console.error('Fout:', err); }
  };

  return (
    <div style={styles.splitView}>
      <StellingenLijst titel="Beschikbare stellingen" stellingen={stellingen} laden={laden} geselecteerdId={gekozen?.id}
        onKies={bekijk} leegTekst="Nog geen stellingen beschikbaar." stijlen={styles} />
      <div style={styles.detailPanel}>
        {gekozen ? (
          <>
            <h2>{gekozen.titel}</h2>
            {gekozen.beschrijving && <p style={styles.beschrijving}>{gekozen.beschrijving}</p>}
            <ChatSamenstelling key={gekozen.id} api={api} stelling={gekozen} />
          </>
        ) : <p style={styles.empty}>Selecteer een stelling</p>}
      </div>
    </div>
  );
}

const styles = { ...basis };
